export default function buildCarbonBarConfig(legendData, data1, data2, dataType1, dataType2) {
  return {
    grid: {
      left: '3%',
      right: '12%',
      bottom: '3%',
      containLabel: true
    },
    tooltip: {
      trigger: 'axis',
      axisPointer: {
        type: 'shadow'
      },
      formatter: function (params) {
        let tar;
        if (params[1].value !== '-') {
          tar = params[1];
        } else {
          tar = params[0];
        }
        return tar.name + '<br/>' + tar.seriesName + ' : ' + Math.abs(tar.value);
      }
    },
    color: ['#F0A4A4', '#B4EFBF'],
    xAxis: {
      type: 'category',
      data: legendData
    },
    yAxis: {
      type: 'value'
    },
    series: [
      {
        name: dataType1,
        stack: 'Total',
        type: 'bar',
        data: data1,
        label: {
          show: true,
          position: 'top',
          formatter: '{c} 吨'
        }
      },
      {
        name: dataType2,
        stack: 'Total',
        type: 'bar',
        data: data2,
        label: {
          show: true,
          position: 'bottom',
          formatter: function (params) {
            return -1 * params.value + " 吨"
          }
        }
      }
    ]
  }
}



// WEBPACK FOOTER //
// ./src/config/chart/config_carbon_bar.js